export const ComponentVersion = ".4"